<template>
  <div>
    <ClientSearchList
      @init="handleClient_init"
      @submit="handleClient_submit"
    />

    <div class="columns my-0 is-multiline">
      <div class="column is-4">
        <kst-input floating-label load-on-focus
          field="Search" :data="searchData" :catalog="DlvSearchCatalog"
          @input="handleInput"
        />
      </div>
      <div class="column is-narrow">
        <kst-output addons floating-label 
          field="ClientID" :data="searchData" :catalog="DlvSearchCatalog"
        >
          <template #default>
            <kst-input floating-label load-on-focus
              field="Client" :data="searchData" :catalog="DlvSearchCatalog"
              :disabled="clientDisabled" @input="handleInput"
            />
          </template>
          <template #right>
            <div class="control">
              <template v-if="searchData.ClientID === null">
                <kst-tooltip search-mode hover-only :content="DlvSearchCatalog.ClientID.Label">
                  <kst-button search-mode @click="handleSearch_client"/>
                </kst-tooltip>
              </template>
              <template v-else>
                <kst-tooltip clear-mode hover-only :content="DlvSearchCatalog.ClientID.Label">
                  <kst-button clear-mode @click="handleClear_client"/>
                </kst-tooltip>
              </template>
            </div>
          </template>
        </kst-output>
      </div>
      <div class="column is-narrow">
        <kst-input floating-label
          field="WarehouseID" :data="searchData" :catalog="DlvSearchCatalog"
          :options="warehouseOptions" @input="handleInput"
        />
      </div>
      <div class="column is-narrow">
        <kst-input floating-label
          field="Status" :data="searchData" :catalog="DlvSearchCatalog"
          :options="statusOptions" @input="handleInput"
        />
      </div>
      <div class="column is-narrow">
        <kst-input floating-label
          field="DepartureDate" :data="searchData" :catalog="DlvSearchCatalog"
          @input="handleInput"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DlvSearchCatalog from "../DlvSearchCatalog.js";
import Model from "../DlvModel.js";
import Services from "../../../services/Api/DeliveryServices.js";

import ClientSearchList from "../../Client/SearchList/CliScL.vue";

export default {
  components:{
    ClientSearchList
  },
  props: {
    searchData: Object,
    warehouseOptions: Object
  },
  data: () => ({
    DlvSearchCatalog: DlvSearchCatalog,
    // func
    showClientFunc: null
  }),
  computed: {
    clientDisabled() {
      return this.searchData.ClientID !== null;
    },
    statusOptions() {
      return Model.createStatusOptions(DlvSearchCatalog.Status.Label);
    }
  },
  methods: {
    /*** by Client modal ***/

    handleClient_init(show) {
      this.showClientFunc = show;
    },
    handleClient_submit(data) {
      this.searchData.ClientID = data.ID;
      this.searchData.Client = data.Name;
      this.handleInput();
    },

    /*** custom ***/

    handleInput() {
      this.$emit(this.$kst.Enum.Event.Input);
    },

    handleSearch_client() {
      this.showClientFunc(Services.getRelatedClientList);
    },
    handleClear_client() {
      this.searchData.ClientID = null;
      this.searchData.Client = "";

      this.handleInput();
    }
  }
}
</script>